@if (
  featureConfiguration?.customApplicationNameAllowed &&
  companySettings?.applicationSettings?.customApplicationName
) {
  <div class="menu-title-container">
    <span class="menu-title"
      >{{ companySettings.applicationSettings.customApplicationName }}
    </span>
  </div>
} @else if (companySettings?.displayName) {
  <div class="menu-title-container">
    <span class="menu-title">{{ companySettings.displayName }}</span>
    <span>&nbsp;</span>
    <span class="ns menu-title-subtext" i18n>Fernhilfe</span>
  </div>
} @else {
  <div class="menu-title-container">
    <span class="ns menu-title-subtext" i18n>blankmile™ Fernhilfe</span>
  </div>
}
